import { Badge } from '@mantine/core';
import { Icon } from '@vrplatform/icons';
import type { ThemeColor } from '@vrplatform/theme';

export const PercentageBadge = ({
  value,
  precision = 2,
  inverseColors = false,
}: {
  value: number | null | undefined;
  precision?: number;
  inverseColors?: boolean;
}) => {
  'use memo';

  if (value === null || value === undefined) return null;

  const getBadgeColor = (): ThemeColor => {
    if (!value) return 'yellow';

    if (inverseColors) {
      return value > 0 ? 'red' : 'teal';
    } else {
      return value > 0 ? 'teal' : 'red';
    }
  };

  const color = getBadgeColor();

  return (
    <Badge
      color={color}
      variant="light"
      leftSection={
        value ? (
          <Icon
            icon={value > 0 ? 'ArrowTopIcon' : 'ArrowBottomIcon'}
            size={12}
            color={(theme) => theme.colors[color][6]}
            strokeWidth={3}
          />
        ) : undefined
      }
    >
      {(value < 0 ? value * -1 : value).toFixed(precision)}%
    </Badge>
  );
};
